import { votedLabel } from '../../../vibe/aggregate';
import CrowdFeelRing from './CrowdFeelRing';

export default function CrowdVibe({
  crowd,
  isHost,
  playing = false,
  songTitle = '',
  notice = '',
  updating = false,
  onUpdate,
}) {
  const submitted = crowd?.submittedCount || 0;
  const eligible = crowd?.eligibleCount || 0;
  const topStyles = crowd?.topStyles || [];
  const topFlavors = crowd?.topFlavors || [];
  const feelStats = crowd?.feelStats || [];

  return (
    <section aria-label="Crowd Vibe" className="w-full min-w-0">
      <div className="mb-4 flex items-baseline justify-between gap-3">
        <h3 className="text-base font-semibold text-white">Crowd Vibe</h3>
        <p className="text-sm text-white/80">{votedLabel(submitted, eligible)}</p>
      </div>

      <div className="py-2 lg:py-4">
        <CrowdFeelRing ring={crowd?.ring} playing={playing} songTitle={songTitle} />
      </div>

      {topStyles.length === 0 ? (
        <p className="mt-2 px-2 text-center text-xs text-white/70">No style trend yet</p>
      ) : (
        <ol className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1 px-1 sm:grid-cols-4">
          {topStyles.map((style) => (
            <li key={style.id} className="truncate text-center text-xs font-medium text-white">
              {style.label}
            </li>
          ))}
        </ol>
      )}

      {feelStats.length > 0 ? (
        <ul className="mx-auto mt-4 grid max-w-md grid-cols-1 gap-1.5">
          {feelStats.map((feel) => (
            <li key={feel.id} className="flex items-center justify-between gap-2 text-xs text-white/90">
              <span className="flex min-w-0 items-center gap-2">
                <span
                  aria-hidden="true"
                  className="inline-block h-2.5 w-2.5 shrink-0 rounded-full border border-white/70"
                  style={{ backgroundColor: feel.color }}
                />
                <span className="truncate">{feel.label}</span>
              </span>
              <span className="shrink-0 tabular-nums">
                {feel.count} / {submitted} · {feel.percent}%
              </span>
            </li>
          ))}
        </ul>
      ) : null}

      {topFlavors.length > 0 ? (
        <div className="mt-4">
          <h4 className="mb-2 text-xs font-medium uppercase tracking-wide text-white/50">Top flavors</h4>
          <ul className="flex flex-wrap gap-1.5" aria-label="Top flavors">
            {topFlavors.map((flavor) => (
              <li
                key={flavor.id}
                className="rounded-full border border-white bg-white/10 px-2.5 py-1 text-xs text-white"
              >
                {flavor.label}
                <span className="sr-only">
                  {`, ${flavor.count} of ${submitted}, ${flavor.percent}%`}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {isHost ? (
        <div className="mt-5">
          <button
            type="button"
            onClick={onUpdate}
            disabled={updating}
            className="mx-auto block w-full max-w-xs rounded-lg bg-white py-3 text-sm font-semibold text-gray-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white disabled:opacity-60"
          >
            {updating ? 'Updating…' : '✨ UPDATE VIBE'}
          </button>
        </div>
      ) : null}
      {notice ? (
        <p role="status" className="mt-2 text-center text-sm text-white/80">{notice}</p>
      ) : null}
    </section>
  );
}
